import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "@mui/material";
import { Block } from "@mui/icons-material";

import TruncatedWithTooltip from "../../../../components/TruncatedWithTooltip";
import { getUserInitials } from "../../../../components/ui";
import { EMPTY_VALUE } from "../constants";

const applicantNameRowPropType = PropTypes.shape({
  nameText: PropTypes.string,
  img: PropTypes.string,
  isBlocked: PropTypes.bool,
}).isRequired;

const ApplicantNameCell = ({ row }) => {
  const name = row.nameText || EMPTY_VALUE;

  return (
    <div className="applicants-page-container__cell-truncate applicants-list-name-cell">
      <Avatar
        src={row.img || undefined}
        alt={name}
        className="applicants-list-name-cell__avatar"
      >
        {getUserInitials(name)}
      </Avatar>
      <div className="applicants-list-name-cell__text">
        <TruncatedWithTooltip title={name}>
          <span className="MuiDataGrid-cellContent applicants-list-name-cell__name">
            {name}
            {row.isBlocked ? (
              <Block color="error" className="mx-2" fontSize="small" />
            ) : null}
          </span>
        </TruncatedWithTooltip>
      </div>
    </div>
  );
};

ApplicantNameCell.propTypes = {
  row: applicantNameRowPropType,
};

export default ApplicantNameCell;
